import React from "react";
import PropTypes from "prop-types";
import { Button } from "../../components";
import { TextInput } from "../../components";
import { FormGroup, FormGroupInput } from "../../components";
import { RadioInput } from "../../components";
import { hasErrorInput } from "../../utils";
import HintIconToolTip from "../../components/HintIconToolTip";

function InspectionResultRegistration({
  settings,
  onSettingChange,
  onSubmit,
  errors,
}) {
  const handleChangeEditTime = (e) => {
    onSettingChange(e.target.name, e.target.value);
  };
  const handleChangeTextMethod = (e) => {
    onSettingChange(e.target.name, e.target.checked);
    if (e.target.checked) {
      onSettingChange("inspection_machine_change_method_select", false);
    }
  };
  const handleChangeSelectMethod = (e) => {
    onSettingChange(e.target.name, e.target.checked);
    if (e.target.checked) {
      onSettingChange("inspection_machine_change_method_text", false);
    }
  };

  return (
    <div
      className={`bg-white lg:w-[820px] lg:h-[468px] w-[640px] border border-tenken-gray-300 rounded-lg lg:px-[60px] lg:py-[30px] px-[30px] py-[15px]`}
      role="tabpanel"
    >
      <h4 className="text-tenken-tablet-heading-4 lg:text-tenken-heading-4 font-bold text-center">
        点検結果登録画面
      </h4>
      <div className="lg:mt-10 mt-5 border border-tenken-gray-250">
        <div className="border-b border-tenken-gray-250 flex">
          <div className="bg-tenken-gray-070 w-[168px] lg:w-[240px] border-r border-tenken-gray-250 lg:py-4 py-2 lg:px-4 px-2">
            <div className="py-2 flex">
              <label>点検結果修正可能時間</label>
              <div className="ml-2 mt-[2px]">
                <HintIconToolTip placement="left">
                  <h4>■点検結果修正可能時間</h4>
                  <p>点検結果を登録後、修正可能な時間を</p>
                  <p>決定します</p>
                  <br />
                  <p>（例）</p>
                  <ul>
                    <li className="ml-3">・2020/5/30 16:00 に点検結果を登録</li>
                    <li className="ml-3">・点検結果修正可能時間は24時間</li>
                  </ul>
                  <p>上記例の場合は、</p>
                  <p>2020/5/30 16:00 ~ 2020/5/31 16:00まで</p>
                  <p>点検結果を修正可能となります</p>
                </HintIconToolTip>
              </div>
            </div>
          </div>
          <div className="lg:pt-4 lg:px-6 pt-2 px-3 lg:w-[460px]">
            <p className="text-left">
              点検結果を修正可能な時間を入力してください
            </p>
            <div className="mt-2 flex items-center">
              <FormGroup direction="vertical">
                <FormGroupInput>
                  <div className="flex items-center">
                    <p>初回登録後</p>
                    <TextInput
                      autoFocus="true"
                      type="text"
                      className={"w-[90px] mx-3"}
                      name="modify_time"
                      onChange={handleChangeEditTime}
                      maxLength={4}
                      pattern="[0-9]*"
                      value={settings.modify_time ?? ""}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      hasError={hasErrorInput(errors, `modify_time`)}
                    />
                    <p>分以内であれば修正可能</p>
                  </div>
                </FormGroupInput>
              </FormGroup>
            </div>
          </div>
        </div>
        <div className="border-b border-tenken-gray-250 flex">
          <div className="bg-tenken-gray-070 lg:w-[240px] w-[168px] border-r border-tenken-gray-250 lg:py-4 py-2 lg:px-4 px-2">
            <div className="py-2 flex">
              <label>入力方法</label>
              <div className="lg:ml-2 ml-1 lg:mt-[2px]">
                <HintIconToolTip>
                  <h4>■設備画面入力方法</h4>
                  <p>点検結果を登録すると、再度点検結果登録</p>
                  <p>画面が開かれます</p>
                  <p>この時に、設備名を手入力するか、または、</p>
                  <p>リストから設備名を選択することで、</p>
                  <p>他の設備の点検結果登録画面へ移行する</p>
                  <p>ことが出来ます</p>
                </HintIconToolTip>
              </div>
            </div>
          </div>
          <div className="lg:py-4 lg:px-6 py-2 px-3 lg:w-[460px]">
            <p className="text-left">設備の画面入力方法を選択してください。</p>
            <div className="mt-2 flex items-center space-x-[36px]">
              <RadioInput
                name="inspection_machine_change_method_text"
                id="inspection_machine_change_method_text"
                onChange={handleChangeTextMethod}
                checked={settings.inspection_machine_change_method_text}
                label="テキスト入力"
              />
              <RadioInput
                name="inspection_machine_change_method_select"
                id="inspection_machine_change_method_select"
                onChange={handleChangeSelectMethod}
                checked={settings.inspection_machine_change_method_select}
                label="リストから選択"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-[50px] mt-[25px] lg:mb-[30px] mb-[15px] flex justify-center">
        <Button
          color="yellow"
          className="min-w-[220px]"
          onClick={onSubmit}
          id="btn-setting-update"
        >
          更新
        </Button>
      </div>
    </div>
  );
}

InspectionResultRegistration.propTypes = {
  show: PropTypes.bool,
};

export default InspectionResultRegistration;
